import {FC} from "react";
import useMaybeNotSetupUser from "contexts/MaybeNotSetupUser/useMaybeNotSetupUser";
import AccountSettings from "../Profile/components/AccountSettings";

const SettingsPage: FC = () => {
  const {user} = useMaybeNotSetupUser();
  if (!user) return null;

  return (
    <div className="h-full overflow-y-auto bg-brand-cream">
      <div className="px-8 py-7">
        <h1 className="text-2xl font-bold text-brand-navy mb-5">Account Settings</h1>
        <AccountSettings email={user.email} showBilling={user.type === "accountant"} />
      </div>
    </div>
  );
};

export default SettingsPage;
